/* eslint-disable @typescript-eslint/no-empty-object-type */
import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import { Highlight, Input, InputGroup, TagPicker } from "rsuite";
import SearchIcon from "@rsuite/icons/esm/react/Search";

import { TagPickerProps } from "rsuite/esm/TagPicker";

import "./LineTypesPicker.less";

interface Props extends Omit<
    TagPickerProps,
    "searchable" | "renderMenu" | "renderMenuItem"
> {}

const LineTypesPicker: FC<Props> = ({ ...props }) => {
    const { t } = useTranslation();
    const [query, setQuery] = useState<string>("");

    const term = query.trim().toLowerCase();

    const matches = (label: React.ReactNode) =>
        label?.toString().toLowerCase().includes(term);

    const handleSearch = (value: string) => {
        setQuery(value);
    };

    return (
        <TagPicker
            searchable={false}
            renderMenu={(menu) => (
                <>
                    <InputGroup className={"line-type-picker__search"}>
                        <Input
                            value={query}
                            size="sm"
                            role={"search"}
                            placeholder={t("search.placeholder")}
                            onChange={handleSearch}
                            // stop keystrokes from bubbling to the picker
                            onKeyDown={(e) => e.stopPropagation()}
                        />
                        <SearchIcon />
                    </InputGroup>
                    {menu}
                </>
            )}
            renderMenuItem={(label) => (
                <div
                    className={
                        matches(label)
                            ? undefined
                            : "line-type-picker__item--hidden"
                    }
                >
                    <Highlight query={query}>{label as string}</Highlight>
                </div>
            )}
            {...props}
        />
    );
};

export default LineTypesPicker;
